<template>
  <g>
    <line
      x1="3.31628"
      y1="20.2695"
      x2="19.5858"
      y2="3.99996"
      class="fill-none"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="3.41421"
      y1="4"
      x2="19.6838"
      y2="20.2695"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconReject",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {},
};
</script>
